module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mn-291814d605941d58335feaba24527a3c.svg";